import * as React from 'react';
import { MarketField } from '@market/react';

export type MarketFormFieldProps = {
  name?: string;
  hasError?: boolean;
  errorMessage?: React.ReactNode | string;
  disabled?: boolean;
  className?: string;
};

export const MarketFormField: React.FC<React.PropsWithChildren<MarketFormFieldProps>> = ({ name, children, hasError, errorMessage, disabled, className }) => {
  const inValid = Boolean(hasError && errorMessage);

  return (
    <MarketField className={className} name={name} invalid={inValid || undefined} disabled={disabled || undefined}>
      {children}
      {inValid && <small slot="error">{errorMessage}</small>}
    </MarketField>
  );
};
